import { Prediction } from "../store/config";
import * as api from "./api";

interface ApiResponse {
  status: number;
  message: string;
  data: Prediction[];
  meta: {
    totalItems: number;
    itemsPerPage: number;
    totalPages: number;
    currentPage: number;
    lastPredictionUpdatedAt: number;
  };
}

const getAuthToken = () => {
  return localStorage.getItem("token") || "{}";
};
// fetch list
// fetch list
export const fetchPredictionList = async (data: {
  search?: string; // Optional search parameter
  page: number;
  limit: number;
}): Promise<ApiResponse> => {
  const params: any = {
    page: data.page,
    limit: data.limit,
  };

  if (data.search) {
    params.search = data.search;
  }

  const token = getAuthToken();
  api.setHeaderAuthorization(token);
  const response: any = await api.get("/predictions", params);
  return response;
};

// add prediction
export const addPrediction = async (token: string, params: Prediction) => {
  try {
    api.setHeaderAuthorization(token);
    const response = await api.post("/predictions", params);
    return response;
  } catch (error) {
    throw error;
  }
};

// update prediction
export const updatePrediction = async (id: string, params: Prediction) => {
  try {
    const token = getAuthToken();
    api.setHeaderAuthorization(token);
    const response = await api.put(`/predictions/${id}`, params);
    return response;
  } catch (error) {
    throw error;
  }
};

// delete prediction
export const deletePrediction = (id: string) => {
  const token = getAuthToken();
  api.setHeaderAuthorization(token);
  return api.remove(`/predictions/${id}`);
};

// clear all table data
export const deleteAll = () => {
  const token = getAuthToken();
  api.setHeaderAuthorization(token);
  return api.remove("/predictions/clear-data");
};
